<template>
    <div>
    <TextBanner>
    Eigentlich sollte diese Betonhülle <strong>20 bis 30 Jahre </strong> lang halten. Doch bereits nach einigen Jahren zeigen sich Risse und schwerwiegende Schäden. Eine neue Lösung muss her.
    </TextBanner>

        
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/06_BetonsarkophagRost_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/06_BetonsarkophagRost_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          
        </Fallback>

    </div>
</template>

<script>
    export default {
        name: 'Betonsarkophag_Rost',
        babylonState: {
            moveCamera: [-7.0, .3, 5, 13, 0.5,0],            

            Geo_Tschernobyl: {

                children: {
                    
                    BG_Sphere: true,

                    Strahl_1: false,
                    Strahl_2: false,
                    Geo_Beton_Sarkophag: false,
                    Geo_Beton_Sarkophag_Rost: true,
                    Geo_Schattenplane_Betonsarkophag: true,
                    Geo_Textur1_Reaktor_4_Damage: false,
                    Geo_Textur1_Reaktor_4_Damage_Aussen: false,
                    Geo_Textur1_Reaktor_4_Damage_Innen: false,
                    

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);

            //this.$babylonController.setClipping(1,2000),  
            this.$babylonController.setClipping(0.1, 20000);
            this.$babylonController.setAutoRotateBehaviour(false),
            this.$babylonController.setCameraRadiusLimit (5,110),
            this.$babylonController.zoomCamera(1.6)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
